import { w3cwebsocket as WebSocket } from "websocket";
process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

export const socketCLientSSL = ( function() {
    var instance;

    function SocketClient() {
        var websocket           = null,
            //websocketStatus     = false,
            disconnected        = [],
            activeActions       = {},
            eventListeners      = {},
            userEventListeners  = {};

        /**
         * Buat Objet baru koneksi webSocket
         * @param {*} host  - hostname / IP Address dari server websocket
         * @param {*} port  - Nomor port server websocket (def: 8080)
         */
        function initWebSocket(host, port){
            if (websocket !== null){
                if (websocket.readyState === WebSocket.OPEN){
                    websocket.close();
                }
            }

            try {
                websocket           = new WebSocket("wss://" + host + ":" + port);
                websocket.onerror   = function(error){
                    console.error(`Server connections is FAILED, please check your connection to the server !`);
                }
            } catch (error) {
                console.error('Websocket Error:',error);
            }
        }
        /**
         * Handler event ketika menerima message dari server Websocket
         */
        function initMessageReceived(){
            websocket.onmessage = (event) => {
                var message     = JSON.parse(event.data),i;
                if (message.hasOwnProperty("event")) {
                    if (eventListeners.hasOwnProperty(message.event)) {
                        for (i = 0; i < eventListeners[message.event].length; i+= 1){
                            eventListeners[message.event][i](message);
                        }
                    }

                    if (message.hasOwnProperty("username")){
                        if (eventListeners.hasOwnProperty(message.username)) {
                            userEventListeners[message.username](message);
                        } else {
                            if (typeof userEventListeners.primaryUser !== 'undefined') {
                                userEventListeners.primaryUser(message);
                            }
                        }
                    }
                } else if (message.hasOwnProperty("action_id")) {
                    if (activeActions.hasOwnProperty(message.action_id)){
                        activeActions[message.action_id](message);

                        delete activeActions[message.action_id];
                    }
                }
            }
        }
        /**
         * Handler event untuk koneksi terputus dari server Websocket
         * @param {regularCallback} callback - Fungsi yang dipanggil jika koneksi ke server putus
         */
        function initDisconnected() {
            if (websocket !== null){
                websocket.onclose = (event) => {
                    var i;
                    if (typeof disconnected !== 'undefined') {
                        for (i = 0; i < disconnected.length; i++){
                            disconnected[i]();
                        }
                    }
                }
            }
        }
        /**
         * Handler untuk generate uniqueId untuk session socket
         */
        function guid() {
            function s4(){
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            }
    
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

        return {
            connectToHost: function(host, port, callback) {
                initWebSocket(host, port);

                if (websocket !== null){
                    websocket.onopen = (event) => {
                        if (typeof callback === 'function'){
                            callback(event);
                        }
                    }
                }

                initMessageReceived();
                initDisconnected();
            },
            sendAction: function(action, callback){
                if (websocket !== null){
                    if (websocket.readyState === WebSocket.OPEN){
                        action.action_id        = guid();
                    } else {
                        callback({success: false, ResponseCode: 503});
                    }
                    if (typeof callback !== 'undefined'){
                        activeActions[action.action_id] = callback;
                    }
                    websocket.send(JSON.stringify(action));
                }
            },
            onEvent: function(eventName, callback){
                if (!eventListeners.hasOwnProperty(eventName)) {
                    eventListeners[eventName]   = [];
                }
                eventListeners[eventName].push(callback);
            },
            onUserEvent: function(username, callback){
                if (username === ""){
                    username = "primaryUser";
                    //console.log('UserEvent tapi username null');
                }
                if (userEventListeners.hasOwnProperty(username)){
                    userEventListeners[username]    = null;
                }
                userEventListeners[username]        = callback;
            },
            removeUserEvent: function(username){
                if (userEventListeners.hasOwnProperty(username)){
                    userEventListeners[username]    = null;
                    delete userEventListeners[username];
                }
            },
            onDisconnected: function(callback){
                if (typeof callback !== 'undefined'){
                    disconnected.push(callback);
                }
            }
        }
    };
    return {
        getInstance: function() {
            if (!instance){
                instance = new SocketClient();
            }

            return instance;
        }
    };
})().getInstance();